import { UsersIcon } from "lucide-react";

import { Group, Heading, Link, Text } from "@chakra-ui/react";

import { Button } from "@components/ui/button";

import { openPlanSelection } from "@utils/monday-plans";

const SEATS_UPGRADE_REQUIRED_SCREEN = ({ email }: { email: string }) => {
  const mailToLink = `mailto:${email}`;

  return (
    <Group flexDirection="column">
      <UsersIcon
        size={48}
        className="text-red-500"
      />

      <Heading size="xl"> Seat Limit Reached</Heading>
      <Text
        mt={2}
        fontSize="md"
        color="gray.600"
        textAlign="center"
        maxW="600px"
      >
        Your current plan has reached its user limit for <strong>Xero for monday.com</strong>. Upgrade your
        plan to add more users and keep your team synced with live Xero data inside monday.com.
      </Text>

      <Button
        mt={6}
        size="md"
        w="full"
        colorPalette="blue"
        onClick={openPlanSelection}
      >
        Upgrade plan
      </Button>

      <Text
        mt={4}
        fontSize="sm"
        color="gray.500"
      >
        Need help? Contact{" "}
        <Link
          href={mailToLink}
          color="blue.500"
        >
          {email}
        </Link>
      </Text>
    </Group>
  );
};

export default SEATS_UPGRADE_REQUIRED_SCREEN;
